import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import {setPageNewItem} from "@/utils";
import './index.scss'
import { getStorage,gotonext} from "@/utils";import {
  refreshMenu,
} from "../../../../../../redux/common/action";
import {getInfo} from "../../../../../../servers/menuAPI";
import {savedata} from "../../../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal} from "antd";
import {dpeannexdefmap} from "../../../../../../utils/dpedatadef";

@CBaseComponent
class Shorttime extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onChange = this.onChange.bind(this)

  }


  state = {
    data: storeManageListNewData,
    addressInfo: null,
  }

  onChange(value){
    const data = this.state.data
    data[0].data.forEach((item,index)=>{
      if (item.id === value.data.id) {
        item.value = value.value
      }
    })
    this.setState({
      data:data
    })
  }


  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
        if (item.id === data.id){
          item.ifEdit = !item.ifEdit
          if (data.hasupload!== '') {
            d.forEach(item1=>{
              if (item1.id === data.hasupload){
                item1.ifEdit = !item1.ifEdit
              }
            })
          }
        }
      })
    this.setState({
      data:result
    })
  }

  onChange(data){
    let currentOption = null;
      if(data.data.id === 'address'){
        currentOption = data.data.options.filter(item=>{
          return item.value === data.value;
        });
      }
    const  d = setPageNewItem(this.state.data, data.data.id, 'value', data.value)
    this.setState({
        data: d,
        addressInfo: currentOption && currentOption.length ? currentOption[0] : null
      })
  }

  onSearch(data, value){
    if(data.data.id === 'address'){
      this.getAMapKeywordsSearchData(data.value);
    }else if(data.data.id === 'user'){
      this.getUserBusniessListData(data);
    }
  }

  onSubmit(data){
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
       this.onSubmitHandler(data)
      }
    });
  }

  onSelect(data=''){
    const params = {
      annual:localStorage.getItem('year'),
      indid:"2.2.2"
    }
    getInfo(params).then(res=>{
            if (res.pagetips) {
        const data = this.state.data
        data[0].pagetips = res.pagetips
        this.setState({
          data:data
        })
      } else {
        const data = this.state.data
        data[0].pagetips = ''
        this.setState({
          data:data
        })
      }
      const data = []
      res.records.forEach((item,index)=>{
        const obj = {}
        obj.id = item.code
        obj.name = item.name
        obj.placeholder=''
        obj.type= item.type === '1G10' ? 'input':'textarea'
        obj.zhengshu1= index === 0 || index === 1 ?true:false
        obj.checkType= item.minlimit > 0 ? 'required' : ''
        obj.newDisabled=false
        obj.editDisabled=false
        obj.newShow=true
        obj.editShow=true
        obj.ifEdit= item.type === '1G10' && item.annuname!=='' ? true : false
        obj.value= item.fillin ? decodeURIComponent(item.fillin): ''
        obj.options=[]
        obj.expand = {
          autosize: {minRows: 4, maxRows: 10}
        }
        obj.showeditbtn = item.type === '1G10' && item.annuname!=='' ? true : false
        obj.hasupload = ''
        obj.jpath = item.code
        obj.tips = item.formtips
        data.push(obj)
        if (item.annexdefids !== '' && item.annexdefids!==undefined) {
          const arr = item.annexdefids.split(',')
          arr.forEach(item1=>{
            const info = JSON.parse(JSON.stringify(dpeannexdefmap[item1]))
            const d = {
              id: info.id,
              name: '附件'+info.id+'.'+info.name,
              placeholder: '',
              type: 'img',
              checkType: '',
              newDisabled: false,
              editDisabled: false,
              newShow: true,
              editShow: true,
              value: [],
              options: [],
              jpath:info.id,
              expand: {
                limit: 100
              },
              btnname: '附件',
            }
            item.annexlist.forEach(item3=>{
              if (item3.catcode === info.id){
                d.value.push(item3)
              }
            })
            data.push(d)
          })
        }
        if (index === 2) {
          for (let i= 0;i<8;i++){
            const specialobj = {}
            specialobj.id =  i===0?'dbxlszlmc':i===1?'dbxlszllx':i===2?'dbxlszlqzsj':i===3?'dbxlszlzpsl':i===4?'dbxlszlgzs':i===5?'dbxlszlztmj':i===6?'dbxlszlhzdw':'dbxlszlhj'
            specialobj.name = i===0?'展览名称':i===1?'展览类型':i===2?'起止时间':i===3?'展品数量(件/套)':i===4?'观众数（人次）':i===5?'展厅面积(平方米)':i===6?'合作单位':'是否获奖(推介)'
            specialobj.placeholder=''
            specialobj.type = i===1 || i === 7?'radio':i===5 || i === 3 || i === 4?'number':'input'
            specialobj.zhengshu1= i === 3 || i === 4 ?true:false
            specialobj.checkType= item.minlimit > 0 ? 'required' : ''
            specialobj.newDisabled=false
            specialobj.editDisabled=false
            specialobj.newShow=true
            specialobj.editShow=true
            specialobj.ifEdit=false
            specialobj.value= i===0?res.extra.dbxlszlmc.toString():i===1?res.extra.dbxlszllx.toString() === ''?'1P10':res.extra.dbxlszllx.toString():i===2?res.extra.dbxlszlqzsj.toString():i===3?res.extra.dbxlszlzpsl.toString():i===4?res.extra.dbxlszlgzs.toString():i===5?res.extra.dbxlszlztmj.toString():i===6?res.extra.dbxlszlhzdw.toString():res.extra.dbxlszlhj.toString()
            specialobj.options= i===1 ? [{name:'境内展',value:'1P10'},{name:'出境展览',value:'1P11'},{name:'入境展览',value:'1P12'}]:i===7?[{name:'是',value:'是'},{name:'否',value:'否'}]:[]
            specialobj.expand = {}
            specialobj.hasupload = ''
            specialobj.jpath =  i===0?'dbxlszlmc':i===1?'dbxlszllx':i===2?'dbxlszlqzsj':i===3?'dbxlszlzpsl':i===4?'dbxlszlgzs':i===5?'dbxlszlztmj':i===6?'dbxlszlhzdw':'dbxlszlhj'
            specialobj.tips = ''
            obj.showeditbtn = false
            data.push(specialobj)
          }
          const table1 = {
            id: 'dbxlszlczr',
            name: '策展人',
            placeholder: '',
            type: 'table1',
            checkType: '',
            newDisabled: true,
            newShow: true,
            ifEdit:false,
            value: res.extra.dbxlszlczr?res.extra.dbxlszlczr:[],
            options: [],
            expand: {},
            hasupload:'',
            showeditbtn:false,
            tips:'',
            jpath:'dbxlszlczr'
          }
          data.push(table1)
          const table = {
              id: 'dbxlszlcztd',
              name: '策展团队其他工作人员',
              placeholder: '',
              type: 'table',
              checkType: '',
              newDisabled: true,
              newShow: true,
              ifEdit:false,
              value: res.extra.dbxlszlcztd?res.extra.dbxlszlcztd:[],
              options: [],
              expand: {},
              hasupload:'',
              showeditbtn:false,
              tips:'',
              jpath:'dbxlszlcztd'
          }
          data.push(table)
      }
      const obj1 = JSON.parse(JSON.stringify(this.state.data))
        obj1[0].data = data
      this.setState({
        data:obj1
      })
        const element = document.getElementById('top');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
        }
    })
    })
  }

  //下一步
  onCancel(data){
    Modal.confirm({
      content: '确认提交数据到下一个填报页面?',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        this.onSubmitHandler(data,'tz')
      }
    })
  }

  onSubmitHandler(data, type=''){
    if (data.status){
      for (let key in data.data) {
        if (typeof data.data[key] !== 'string' && typeof data.data[key] !== 'number' && key !=='dbxlszlczr' &&  key !=='dbxlszlcztd' &&  key !=='dbxlszllx'){
            delete data.data[key]
        }
      }
      const params = JSON.parse(JSON.stringify(data.data))
      params.annual = localStorage.getItem('year')
      console.log(params);
      savedata(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
           if (type === 'tz'){
            gotonext()
            this.props.history.push({
              pathname: '/informationDeclaration/service/teac/explain',
            });
          }
        } else {
          message.error(res.statemessage);
        }
      })
    }
  }

  componentDidMount(){
    this.onSelect()
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <CPageNew
            data={this.state.data}
            onChange={this.onChange}
            onSearch={this.onSearch}
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
            onChangeEdit={this.onChangeEdit}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Shorttime);

